// extracted by mini-css-extract-plugin
export default {"submit_btn_wrapper":"loaderButton_submit_btn_wrapper__ADEVd"};